export const DrawerSidebarWidth = 620;
